/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import React, { useEffect, useState } from 'react';
import { getRuntimeOrg } from '@/utils/runtimeOrg';

function titleCaseOrg(org: string) {
  return org
    .toLowerCase()
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');
}

function brandFromOrg(org: string) {
  if (org === 'lims') return 'Land Information Management System';
  // nyandarua -> NyandaruaPay
  return `${titleCaseOrg(org)}Pay`;
}

function getOrgFromHtml(): string | null {
  if (typeof document === 'undefined') return null;
  return document.documentElement.dataset.org || null;
}

export default function FooterCopyright() {
  const [brand, setBrand] = useState<string>(''); // avoid hydration mismatch

  useEffect(() => {
    const org = (
      getOrgFromHtml() ||
      getRuntimeOrg() ||
      'nyandarua'
    ).toLowerCase();
    setBrand(brandFromOrg(org));
  }, []);

  return (
    <div className="mt-8 text-xs text-gray-400">
      © {new Date().getFullYear()} {brand || 'Customer Portal'}. All rights reserved.
    </div>
  );
}
